const state = {
    vIndustry: null,
    vMarketArea: null,
    vSalesClass: null,
    vFavoriteIndustries: [],
    vFavoriteMarketAreas: [],
    vFavoriteSalesClass: [],
    vSearchInputIndustry: null,
    vSearchInputMarketArea: null,
    vSearchIndustries: [],
    vSearchMarketAreas: [],
    vSearchLoadingIndustry: false,
    vSearchLoadingMarketArea: false,
    vProfileId: 0,
    vPdf: null,
};

const mutations = {
  V_SET_INDUSTRY: (state, vIndustry) => {
    state.vIndustry = vIndustry;
  },
  V_SET_MARKET_AREA: (state, vMarketArea) => {
    state.vMarketArea = vMarketArea;
  },
  V_SET_SALES_CLASS: (state, vSalesClass) => {
    state.vSalesClass = vSalesClass;
  },
  V_SET_PROFILE_ID: (state, vProfileId) => {
    state.vProfileId = vProfileId;
  },
  V_SET_FAVORITE_INDUSTRIES: (state, vIndustry) => {
    state.vFavoriteIndustries = vIndustry;
  },
  V_SET_FAVORITE_MARKET_AREAS: (state, vMarketArea) => {
    state.vFavoriteMarketAreas = vMarketArea;
  },
  V_SET_FAVORITE_SALES_CLASS: (state, vSalesClass) => {
    state.vFavoriteSalesClass = vSalesClass;
  },
  V_SET_SEARCH_INPUT_INDUSTRY: (state, vSearchInputIndustry) => {
    state.vSearchInputIndustry = vSearchInputIndustry;
  },
  V_SET_SEARCH_INPUT_MARKET_AREA: (state, vSearchInputMarketArea) => {
    state.vSearchInputMarketArea = vSearchInputMarketArea;
  },
  V_SET_SEARCH_INDUSTRIES: (state, vSearchIndustries) => {
    state.vSearchIndustries = vSearchIndustries;
  },
  V_SET_SEARCH_MARKET_AREAS: (state, vSearchMarketAreas) => {
    state.vSearchMarketAreas = vSearchMarketAreas;
  },
  V_SET_SEARCH_LOADING_INDUSTRY: (state, vSearchLoadingIndustry) => {
    state.vSearchLoadingIndustry = vSearchLoadingIndustry;
  },
  V_SET_SEARCH_LOADING_MARKET_AREA: (state, vSearchLoadingMarketArea) => {
    state.vSearchLoadingMarketArea = vSearchLoadingMarketArea;
  },
  V_PUSH_TO_FAVORITE_INDUSTRIES: (state, vIndustry) => {
    state.vFavoriteIndustries.push(vIndustry);
  },
  V_PUSH_TO_FAVORITE_MARKET_AREAS: (state, vMarketArea) => {
    state.vFavoriteMarketAreas.push(vMarketArea);
  },
  V_PUSH_TO_FAVORITE_SALES_CLASSES: (state, vSalesClass) => {
    state.vFavoriteSalesClass.push(vSalesClass);
  },
  V_SET_PDF: (state, vPdf) => {
    state.vPdf = vPdf;
  },
};

const getters = {
  vIndustry: (state) => state.vIndustry,
  vMarketArea: (state) => state.vMarketArea,
  vSalesClass: (state) => state.vSalesClass,
  vProfileId: (state) => state.vProfileId,
  vFavoriteIndustries: (state) => state.vFavoriteIndustries,
  vFavoriteMarketAreas: (state) => state.vFavoriteMarketAreas,
  vFavoriteSalesClass: (state) => state.vFavoriteSalesClass,
  vSearchInputIndustry: (state) => state.vSearchInputIndustry,
  vSearchInputMarketArea: (state) => state.vSearchInputMarketArea,
  vSearchIndustries: (state) => state.vSearchIndustries,
  vSearchMarketAreas: (state) => state.vSearchMarketAreas,
  vSearchLoadingIndustry: (state) => state.vSearchLoadingIndustry,
  vSearchLoadingMarketArea: (state) => state.vSearchLoadingMarketArea,
  vPdf: (state) => state.vPdf,
};

const vestimateSelection = {
    state,
    getters,
    mutations,
};

export default vestimateSelection;